<template>
    <div class="activity-module">
        <div class="title g-flex-center-center">
            <div class="icon-title2"></div>
            <div class="title-text">
                <p class="title-text-1">我的国庆花样生活</p>
                <p class="title-text-2">分享假期，赢限定好礼！</p>
            </div>
            <div class="icon-title2 title-right"></div>
            <div class="title-bg icon-title-bg2"></div>
        </div>
        <div class="desc">
            <div class="desc-icon icon-activity-mountain"></div>
            出门远行 or
            <div class="desc-icon icon-activity-house"></div>
            宅家躺平？国庆长假怎么过，都由你定义！无论你是准备出门看世界，还是打算在家补番看书，快来分享你的假期计划与精彩瞬间，赢取七猫专属好礼吧～
        </div>
        <p class="sub-title text">活动奖励：</p>
        <p class="text">所有符合主题的帖子作者，都有机会获得<span class="text-mark"> 限定头像挂件《绘梦山河》</span></p>
        <p class="text">优质内容创作者和神评发布者，更可额外解锁 <span class="text-mark"> 动态头像挂件！</span></p>
        <p class="sub-title text">活动时间：</p>
        <p class="text">2025年9月25日 - 10月8日</p>
        <div class="icon-activity-title"></div>
        <p class="tip">以图文帖形式在以下任一话题中发布你的假期分享</p>

        <div class="type-item g-flex-start-center" @click="onShowTopic(1)">
            <div class="type-item-icon icon-activity-mountain2"></div>
            <div>
                <p class="type-item-title"># 我的国庆旅行计划</p>
                <p class="type-item-tip">晒出行计划、旅途美景</p>
            </div>
            <p class="type-item-btn button-2 g-flex-center-center">出门远行</p>
        </div>
        <div class="type-item g-flex-start-center" @click="onShowTopic(2)">
            <div class="type-item-icon icon-activity-house2"></div>
            <div>
                <p class="type-item-title"># 国庆宅家做点啥</p>
                <p class="type-item-tip">分享宅家书影音、休闲日常</p>
            </div>
            <p class="type-item-btn button-2 g-flex-center-center">宅家躺平</p>
        </div>
    </div>
</template>
<script lang="ts" setup>
const emits = defineEmits(['showTopic']);
const onShowTopic = (type: number) => {
    emits('showTopic', type);
};
</script>
<style lang="scss" scoped></style>
